@for (hero of heroes(); track hero.id) {
  <ng-template [paiInsertDynamicHero]="hero" />
}
@for (section of sections(); track section.id) {
  <ng-template [paiInsertDynamicSection]="section" />
}
